import React, { createContext, useContext, useState } from 'react';
const SettingsContext = /*#__PURE__*/createContext(null);
export const SettingsProvider = _ref => {
  let {
    children,
    config,
    onSpeedChange,
    onQualityChange,
    selectedQuality,
    qualities
  } = _ref;
  const [playbackRate, setRate] = useState(1);
  const setPlaybackRate = value => {
    setRate(value);
    onSpeedChange(value);
  };
  return /*#__PURE__*/React.createElement(SettingsContext.Provider, {
    value: {
      config,
      playbackRate,
      setPlaybackRate,
      setQualityLevel: onQualityChange,
      selectedQuality,
      qualities
    }
  }, children);
};
export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === null) {
    throw new Error('SettingsContext is null');
  }
  return context;
};
//# sourceMappingURL=SettingsProvider.js.map